import React from 'react';

const SvgSy = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="SY_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="SY_svg__b" fill="#fff">
        <use xlinkHref="#SY_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#262626" mask="url(#SY_svg__b)" d="M0 13.333h28V20H0z" />
      <path fill="#E32139" mask="url(#SY_svg__b)" d="M0 0h28v6.667H0z" />
      <path
        fill="#128A49"
        mask="url(#SY_svg__b)"
        d="M9.333 11.093l-1.567 1.064.528-1.82-1.497-1.161 1.894-.06.642-1.783.643 1.782 1.893.061-1.496 1.162.528 1.82zM18.667 11.093l-1.568 1.064.528-1.82-1.496-1.161 1.893-.06.643-1.783.642 1.782 1.894.061-1.497 1.162.528 1.82z"
      />
    </g>
  </svg>
);

export default SvgSy;
